import React from 'react';
import { Icon } from './Icon.js';
export const IconCodeCommitFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M17,9.75H1c-.414,0-.75-.336-.75-.75s.336-.75,.75-.75H17c.414,0,.75,.336,.75,.75s-.336,.75-.75,.75Z", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("circle", { cx: "9", cy: "9", r: "4", fill: "currentColor" })));
};
//# sourceMappingURL=IconCodeCommitFill18.js.map